export function settingReducer(state = null, action) {
	switch (action.type) {
		case "SETTING":
			return action.payload;
		default:
			return state;
	}
}
